import type { SystemConfig } from "../common/type-state";

export enum APIHosts {
  Identity = "hostIdentity",
  Stream = "hostStream",
  File = "hostFile",
  Conversion = "hostConversion",
  Bim = "hostBim",
  DOCAI = "hostDOCAI",
  Authen = "authenUrl",
  Upload = "hostUpload",
  App = "hostApp",
  SignalR = "hostSignalR",
  Project = "hostProject",

  Analysis = "File",
  Lakehouse = "lakehouse",
}

export class ApiReduxHelpers {
  config = {} as SystemConfig;

  getHost = (apiHost: APIHosts): string => {
    const val = this.config?.[apiHost as keyof SystemConfig] as
      | string
      | undefined;
    // Default same-origin for App so `${host}/api/...` -> `/api/...`
    if (!val && apiHost === APIHosts.App) return "";
    return val ?? "";
  };

  setConfig = (config: SystemConfig): this => {
    this.config = config;
    return this;
  };
}
